// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const reduceLicensees = licensees => {
  // creates a map of the licensees where owner_code is the key.
  const mappedLicensees = (
    licensees.reduce((a, d, i) => (
      a.set(d.owner_code, d.company_name)
    ), new Map())
  )

  // converts that into an array for us to render in the UI.
  return (
    Array.from(
      mappedLicensees.entries(),
      ([key, value]) => ({
        company_name: value,
        owner_code: key,
      })
    )
  )
}

export default reduceLicensees
